/**
 * Overlay presentation modes (SSOT for web + mobile).
 */
export const OVERLAY_MODES = {
  FORM: 'form',
  DIALOG: 'dialog',
  ACTION_SHEET: 'action-sheet',
} as const;

export type OverlayMode = (typeof OVERLAY_MODES)[keyof typeof OVERLAY_MODES];

/**
 * Product default: long forms are full-height, top-aligned, with natural page scroll.
 */
export const OVERLAY_DEFAULT_MODE: OverlayMode = OVERLAY_MODES.FORM;

export const FORM_OVERLAY_LAYOUT = {
  minHeightCss: '100dvh',
  maxHeightCss: 'none',
  align: 'top' as const,
  stickyFooter: false,
  bodyInnerScroll: false,
} as const;

/** Узкая карточка диалога (центр, попапы). FORM / fullscreen-календарь — отдельные правила. */
export const DIALOG_CARD_MAX_WIDTH_CSS = 'min(420px, calc(100vw - 20px))' as const;

